var map = {
	"./chart-bar-hori-multi.svg": "bd4f",
	"./chart-bar-hori-single.svg": "2679",
	"./chart-bar-vert-multi.svg": "c983",
	"./chart-bar-vert-single.svg": "2ac5",
	"./chart-line-area-multi.svg": "1364",
	"./chart-line-area-single.svg": "7c49",
	"./chart-line-multi.svg": "68f2",
	"./chart-line-single.svg": "67bf",
	"./chart-pie.svg": "63d2",
	"./chart-radar.svg": "f05f",
	"./chart-stack-bar-hori.svg": "9638",
	"./chart-stack-bar-vert.svg": "b482",
	"./copy.svg": "1d79",
	"./err-network-2segments.svg": "f3c1",
	"./err-network-3segments.svg": "0f1f",
	"./group-text.svg": "3c4f",
	"./hon_hoac_bang.svg": "89ba",
	"./impression.svg": "7b93",
	"./nho_hoac_bang.svg": "b18c",
	"./score.svg": "f1f1",
	"./single-info.svg": "6f17",
	"./stats-network-multi-serv.svg": "c566",
	"./table-screen.svg": "b978",
	"./table.svg": "ac31",
	"./text-card.svg": "f9e8",
	"./time-line.svg": "868c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1d3d";